import {
  FETCH_DOOR_ACCESS_RESPONSE,
  LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE,
  SAVE_DOOR_ACCESS_RESPONSE,
  REMOVE_DOOR_ACCESSES_RESPONSE,
  LOGOUT_RESPONSE,
  ENABLE_DOOR_ACCESSES_RESPONSE,
  DISABLE_DOOR_ACCESSES_RESPONSE,
} from '../constants'

const initialState = {}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DOOR_ACCESS_RESPONSE:
      return {
        ...state,
        [action.doorAccess.id]: { ...action.doorAccess },
      }

    case LIST_COMMUNITY_DOOR_ACCESSES_RESPONSE: {
      const doorAccesses = action.doorAccesses || []
      const users = {}
      doorAccesses.forEach((u) => {
        users[u.id] = { ...u }
      })
      return {
        ...state,
        ...users,
      }
    }

    case SAVE_DOOR_ACCESS_RESPONSE:
      return {
        ...state,
        [action.access.id]: { ...action.access },
      }

    case DISABLE_DOOR_ACCESSES_RESPONSE:
    case ENABLE_DOOR_ACCESSES_RESPONSE: {
      const accesses = action.accesses || []
      const updatedUsers = {}
      accesses.forEach((u) => {
        updatedUsers[u.id] = { ...u }
      })
      return {
        ...state,
        ...updatedUsers,
      }
    }

    case REMOVE_DOOR_ACCESSES_RESPONSE: {
      const filtered = Object.keys(state)
        .filter((key) => !action.accessIds.includes(parseInt(key, 10)))
        .reduce((obj, key) => {
          // eslint-disable-next-line no-param-reassign
          obj[key] = state[key]
          return obj
        }, {})

      return { ...filtered }
    }

    case LOGOUT_RESPONSE:
      return initialState

    default:
      return state
  }
}
